import React, { useEffect, useRef } from "react";
import {
  Modal,
  Table,
  Button,
  Row,
  Col,
  FormControl,
  FormGroup,
  ControlLabel,
  Tab,
} from "react-bootstrap";
import Select from "react-select";
import "./MedicineWiseBatchersSelect.css";

import { useState } from "react";

const PurchaseRequest = ({
  onCreatePurchaseOrder,
  medicineName,
  show,
  onHide,
  isSubmitting,
  getSupplierOption,
  enterPoQty,
  setEnterPoQty,
  setSelectedSupplier,
  selectedSupplier,
}) => {
  return (
    <Modal show={show} onHide={onHide} bsSize="lg" backdrop="static"  dialogClassName="po-modal-70">
      <Modal.Header closeButton>
        <Modal.Title>Purchase Order</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table>
          <thead>
            <tr>
              <th
                style={{
                  fontSize: "16px",
                  width: "30%",
                  textTransform: "uppercase",
                  fontWeight: "600",
                  color: "#333",
                }}
              >
                Medicine Name
              </th>
              <th
                style={{
                  fontSize: "16px",
                  width: "30%",
                  textTransform: "uppercase",
                  fontWeight: "600",
                  color: "#333",
                }}
              >
                Quantity
              </th>
              <th
                style={{
                  fontSize: "16px",
                  width: "30%",
                  textTransform: "uppercase",
                  fontWeight: "600",
                  color: "#333",
                }}
              >
                Select Supplier
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <FormControl
                  type="text"
                  name="Medicine"
                  placeholder="Medicine Name"
                  value={medicineName || ""}
                  readOnly
                />
              </td>
              <td>
                <FormControl
                  placeholder="Qty"
                  type="number"
                  name="qty"
                  min="1"
                  required
                  //   inputRef={(el) => {
                  //     qtyInputRef.current = el;
                  //   }}
                  value={enterPoQty}
                  disabled={!!isSubmitting}
                  onChange={(e) => setEnterPoQty(e.target.value)}
                />
              </td>
              <td>
                <Select
                  placeholder="Select Supplier"
                  options={getSupplierOption}
                  value={selectedSupplier}
                  onChange={setSelectedSupplier}
                  isClearable
                />
              </td>
            </tr>
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-danger" onClick={onHide}>
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-success"
          onClick={onCreatePurchaseOrder}
          disabled={!!isSubmitting}
        >
          {isSubmitting ? "Submitting..." : "Submit"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default PurchaseRequest;
